import { createPaginator } from "@smithy/core";
import { ChimeSDKMessagingClient } from "../ChimeSDKMessagingClient";
import { ListChannelMembershipsForAppInstanceUserCommand, } from "../commands/ListChannelMembershipsForAppInstanceUserCommand";
export const paginateListChannelMembershipsForAppInstanceUser = createPaginator(ChimeSDKMessagingClient, ListChannelMembershipsForAppInstanceUserCommand, "NextToken", "NextToken", "MaxResults");
